export default __webpack_public_path__ + "static/media/Epic.ecc82077.png";